import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _toArray from "@babel/runtime/helpers/toArray";
import "core-js/modules/es6.object.get-own-property-names.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import MemoryQueueAsync from './queue/MemoryQueueAsync';

// read the api signature of the default queue implementation to assert matching api for any custom `options.queue`
// eslint-disable-next-line no-unused-vars
var _Object$getOwnPropert = Object.getOwnPropertyNames(MemoryQueueAsync.prototype),
  _Object$getOwnPropert2 = _toArray(_Object$getOwnPropert),
  constructor = _Object$getOwnPropert2[0],
  QUEUE_API_METHODS = _Object$getOwnPropert2.slice(1);

/**
 * https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred
 */
var createDeferredPromise = function createDeferredPromise() {
  var resolve;
  var reject;
  var promise = new Promise(function (_resolve, _reject) {
    resolve = _resolve;
    reject = _reject;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};
export default function createBatchTransportQueue() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delay = options.delay,
    delay = _options$delay === void 0 ? 100 : _options$delay,
    _options$queue = options.queue,
    queue = _options$queue === void 0 ? new MemoryQueueAsync() : _options$queue,
    transport = options.transport,
    _options$beforeTransp = options.beforeTransport,
    beforeTransport = _options$beforeTransp === void 0 ? function (events) {
      return events;
    } : _options$beforeTransp,
    _options$onError = options.onError,
    onError = _options$onError === void 0 ? function () {} : _options$onError,
    _options$onTransportR = options.onTransportResults,
    onTransportResults = _options$onTransportR === void 0 ? function () {} : _options$onTransportR;

  // assert options
  if (typeof transport !== 'function') {
    throw new Error('options.transport method required to createBatch');
  }

  // assert signature of async queue
  if (_typeof(queue) !== 'object' && typeof queue !== 'function') {
    throw new Error("createQueue: asyncQueue must be an object or a function, got: ".concat(queue));
  }

  // assert api methods exist in async queue
  QUEUE_API_METHODS.forEach(function (name) {
    if (typeof queue[name] !== 'function') throw new Error("createQueue: asyncQueue.".concat(name, " must be a function, got: ").concat(queue[name]));
  });

  /**
   * A deferred promise object that will resolve the next time events are
   * flushed. This is returned on calls to schedule().
   */
  var deferredFlushPromise = createDeferredPromise();

  /**
   * Timeout id used to schedule deferred flush() calls.
   */
  var scheduledFlushTimeoutId = null;
  function doTransport() {
    return _doTransport.apply(this, arguments);
  }
  /**
   * Flush any currently queued events, sending them over the network.
   *
   * Flush can either be called directly or indirectly via schedule(). When
   * called directly, we'll clear any scheduled calls too since a flush is
   * already happening.
   */
  function _doTransport() {
    _doTransport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var events, processedEvents, results;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return queue.dequeue();
            case 2:
              events = _context.sent;
              if (!(!events || !events.length)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", null);
            case 5:
              _context.next = 7;
              return beforeTransport(events);
            case 7:
              processedEvents = _context.sent;
              _context.next = 10;
              return transport(processedEvents);
            case 10:
              results = _context.sent;
              // notify other parties about the result of transporting
              onTransportResults({
                events: processedEvents,
                results: results
              });
              return _context.abrupt("return", results);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _doTransport.apply(this, arguments);
  }
  function doFlush() {
    return _doFlush.apply(this, arguments);
  }
  /**
   * Schedule events to be sent after waiting `delay` ms in order to allow
   * batching events together. Returns a promise that resolves once events
   * have been sent.
   */
  function _doFlush() {
    _doFlush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var deferredPromise;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // Reset async state
              if (scheduledFlushTimeoutId !== null) {
                clearTimeout(scheduledFlushTimeoutId);
                scheduledFlushTimeoutId = null;
              }
              deferredPromise = deferredFlushPromise;
              deferredFlushPromise = createDeferredPromise();

              // Do transport
              _context2.prev = 3;
              _context2.next = 6;
              return doTransport();
            case 6:
              _context2.next = 19;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](3);
              _context2.prev = 10;
              onError(_context2.t0);
              _context2.next = 19;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t1 = _context2["catch"](10);
              if (!(process.env.NODE_ENV === 'test')) {
                _context2.next = 19;
                break;
              }
              deferredPromise.reject(_context2.t1);
              return _context2.abrupt("return", deferredPromise.promise);
            case 19:
              deferredPromise.resolve();
              return _context2.abrupt("return", deferredPromise.promise);
            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 8], [10, 14]]);
    }));
    return _doFlush.apply(this, arguments);
  }
  function scheduleFlush() {
    return _scheduleFlush.apply(this, arguments);
  }
  function _scheduleFlush() {
    _scheduleFlush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (scheduledFlushTimeoutId === null) {
                scheduledFlushTimeoutId = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          scheduledFlushTimeoutId = null;
                          doFlush();
                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), delay);
              }
              return _context4.abrupt("return", deferredFlushPromise.promise);
            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _scheduleFlush.apply(this, arguments);
  }
  function flush() {
    return _flush.apply(this, arguments);
  }
  function _flush() {
    _flush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _ref2,
        _ref2$immediate,
        immediate,
        _args5 = arguments;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref2 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, _ref2$immediate = _ref2.immediate, immediate = _ref2$immediate === void 0 ? true : _ref2$immediate;
              if (!immediate) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", doFlush());
            case 3:
              return _context5.abrupt("return", scheduleFlush());
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _flush.apply(this, arguments);
  }
  function enqueue(_x) {
    return _enqueue.apply(this, arguments);
  }
  function _enqueue() {
    _enqueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(event) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return queue.enqueue(event);
            case 3:
              _context6.next = 8;
              break;
            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              // Report error to onError callback, but still return a resolve promise
              onError(_context6.t0);
            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 5]]);
    }));
    return _enqueue.apply(this, arguments);
  }
  return {
    flush: flush,
    enqueue: enqueue
  };
}